import { filter, over } from 'lodash';

type Ref = (el: HTMLElement | null) => void;

export default (...fns: Array<Ref | undefined | null>) =>
  over(filter(fns) as Ref[]);
